import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
interface PropsType {
	[x: string]: any;
	justifyContent?: any;
	alignItems?: any;
	alignContent?: any;
	inline?: any;
	wrap?: any;
	className?: any;
	tag?: string | "div";
	children?: any;
	breakpoint?: any;
	direction?: any;
}
const Flex: React.FC<PropsType> = ({
	justifyContent,
	alignItems,
	alignContent,
	inline,
	wrap,
	className,
	tag,
	children,
	breakpoint,
	direction,
	...rest
}) => {
	const Tag = "div";
	return (
		<Tag
			className={classNames(
				{
					[`d-${breakpoint ? breakpoint + "-" : ""}flex`]: !inline,
					[`d-${breakpoint ? breakpoint + "-" : ""}inline-flex`]: inline,
					[`flex-${direction}`]: direction,
					[`justify-content-${justifyContent}`]: justifyContent,
					[`align-items-${alignItems}`]: alignItems,
					[`align-content-${alignContent}`]: alignContent,
					[`flex-${wrap}`]: wrap,
				},
				className,
			)}
			{...rest}>
			{children}
		</Tag>
	);
};

Flex.propTypes = {
	children: PropTypes.node.isRequired,
	justifyContent: PropTypes.string,
	inline: PropTypes.bool,
	alignItems: PropTypes.string,
	alignContent: PropTypes.string,
	wrap: PropTypes.string,
	className: PropTypes.string,
	tag: PropTypes.string,
	breakpoint: PropTypes.string,
	direction: PropTypes.string,
};

export default Flex;
